import { __awaiter } from "tslib";
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCheckinOrderQuery, useResetOrderPaymentBlockMutation } from '@websky/graphql';
import { getCheckinOrderId } from '../../../store/order/selectors';
import { setCheckinOrder } from '../../../store/order/actions';
import { CheckinStep } from '../../../types';
import { useSteps } from '../../../utils';
export const useUnlockOrder = (setLoading) => {
    const dispatch = useDispatch();
    const orderId = useSelector(getCheckinOrderId);
    const { refetch } = useGetCheckinOrderQuery({ fetchPolicy: 'no-cache', skip: true });
    const [resetOrderPaymentBlock] = useResetOrderPaymentBlockMutation();
    const { setStep, goToNextStep } = useSteps();
    const _unlockOrder = useCallback(({ onUnlock, onNotBlocked }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        try {
            setLoading === null || setLoading === void 0 ? void 0 : setLoading(true);
            const order = (_b = (_a = (yield refetch({ id: orderId }))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.CheckinOrder;
            if (!order) {
                return;
            }
            dispatch(setCheckinOrder(order));
            if (!order.isBlockedForPayment) {
                onNotBlocked();
                return;
            }
            const orderIsUnlocked = (_d = (_c = (yield resetOrderPaymentBlock({ variables: { id: orderId } }))) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.ResetOrderPaymentBlock;
            if (!orderIsUnlocked) {
                return;
            }
            const unlockedOrder = (_f = (_e = (yield refetch({ id: orderId }))) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.CheckinOrder;
            if (!unlockedOrder) {
                return;
            }
            dispatch(setCheckinOrder(unlockedOrder));
            onUnlock();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setLoading === null || setLoading === void 0 ? void 0 : setLoading(false);
        }
    }), [dispatch, orderId, resetOrderPaymentBlock, refetch, setLoading]);
    const unlockOnBackToOrder = () => {
        _unlockOrder({
            /**
             * checkinIsBlockedForPayment в замыкании useSteps (goToNextStep) ещё указывает
             * на состояние до снятия блокировки, поэтому передаём ignoreBlockedForPayment, чтобы
             * getNextStepEnum не увёл повторно на шаг оплаты. Шаг вычисляется через доступные
             * шаги заказа, а не хардкодится на Baggage, которого может не быть у заказа
             * (например, при заморозке цены)
             */
            onUnlock: () => goToNextStep(CheckinStep.Passengers, false, true),
            onNotBlocked: () => {
                goToNextStep(CheckinStep.Passengers, false, true);
            }
        });
    };
    const unlockOnPaymentClick = () => {
        _unlockOrder({
            onUnlock: () => setStep(CheckinStep.Payment),
            onNotBlocked: () => setStep(CheckinStep.Payment)
        });
    };
    return {
        unlockOnBackToOrder,
        unlockOnPaymentClick
    };
};
